import {useState} from 'react';
import {Link} from 'react-router-dom';
import {motion,AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {services} from '../data/site';

const {FiArrowUpRight} = FiIcons;

function ServicePanels() {
  const [active, setActive] = useState(0);

  return (
    <div className="flex h-[720px] flex-col gap-3 md:h-[600px] md:flex-row">
      {services.map((s, i) => {
        const on = active === i;
        return (
          <motion.div
            key={s.slug}
            role="button"
            tabIndex={0}
            aria-expanded={on}
            onMouseEnter={() => setActive(i)}
            onFocus={() => setActive(i)}
            onClick={() => setActive(i)}
            animate={{flexGrow: on ? 4 : 1}}
            transition={{duration: 0.7, ease: [0.22, 1, 0.36, 1]}}
            className="relative min-h-0 min-w-0 flex-1 basis-0 cursor-pointer overflow-hidden bg-ink text-white outline-none focus-visible:ring-2 focus-visible:ring-brick"
          >
            <motion.img
              src={s.image}
              alt={`${s.title} paver inspiration`}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
              animate={{scale: on ? 1.02 : 1.15, opacity: on ? 1 : 0.55}}
              transition={{duration: 0.9}}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-clay">0{i + 1}</p>
              <h3 className="h-display mt-1 whitespace-nowrap text-3xl md:text-5xl">{s.title.split(' ')[0]}</h3>
              <AnimatePresence>
                {on && (
                  <motion.div
                    initial={{opacity: 0, y: 20}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.5, delay: 0.2}}
                    className="mt-4 max-w-sm"
                  >
                    <p className="text-sm leading-6 text-white/80">{s.text}</p>
                    <Link
                      to="/services"
                      className="mt-5 inline-flex items-center gap-3 border-b border-white/60 pb-1 text-xs font-bold uppercase tracking-widest hover:text-clay"
                    >
                      Explore <SafeIcon icon={FiArrowUpRight} />
                    </Link>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}

export default ServicePanels;
